// ReSharper disable MisuseOfOwnerFunctionThis
(function ($, ko) {
    // custom validation rules
    ko.validation.rules.exactLength = {
        validator: function (val, param) {

            if (val === null || val === undefined || val.toString().trim().length === 0)
                return true;

            var isArray = param instanceof Array;
            if (!isArray)
                param = [param];

            var valid = false;
            for (var i = 0; i < param.length; i++) {
                if (val.toString().trim().length === param[i]) {
                    valid = true;
                    break;
                }
            }

            return valid;
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.exact-length')
    };

    ko.validation.rules.minLength = {
        validator: function(val, param) {
            if (val === null || val == undefined)
                return true;

            if (typeof (val) !== 'string' && !$.isNumeric(val))
                return false;

            var length = val.toString().trim().length;
            return length >= param;
        },
        message: 'min length {0} chars'
    };

    ko.validation.rules.betweenLength = {
        validator: function(val, param) {
            if (val === null || val === undefined)
                return true;

            if (typeof (val) !== 'string' || !$.isNumeric(val))
                return false;

            var length = val.toString().trim().length;
            return length >= param[0] && length <= param[1];
        },
        message: '{0} to {1} chars'
    };

    ko.validation.rules.betweenLengthString = {
        validator: function(val, param) {
            if (val === null || val === undefined)
                return true;

            if (typeof (val) !== 'string')
                return false;

            var length = val.toString().trim().length;
            return length >= param[0] && length <= param[1];
        },
        message: '{0} to {1} chars'
    };

    ko.validation.rules.notpattern = {
        validator: function (val, regex) {
            return val === null || val === undefined || val.toString().match(regex) === null;
        },
        message: 'Please check this value.'
    };

    ko.validation.rules.betWeenDates = {
        validator: function (val, param) {
            if (!val)
                return true;

            var startDate = ko.unwrap(param[0]);
            var endDate = ko.unwrap(param[1]);

            var inputDate = moment(val).startOf('day');
            var d1 = moment(startDate).startOf('day');
            var d2 = moment(endDate).startOf('day');

            return d1 < inputDate && d2 > inputDate;
        },
        message: 'must be numeric'
    };

    ko.validation.rules.custom = {
        validator: function (val, param) {
            return param(val);
        }
    };

    ko.validation.rules.ssn = {
        validator: function (val, param) {
            if (!param || val === null || val === undefined || val.toString().trim().length === 0)
                return true;

            var normalizedVal = val.replace(/-/g, '').trim();
            var area = parseInt(normalizedVal.substring(0, 3));
            var group = parseInt(normalizedVal.substring(3, 5));
            var serial = parseInt(normalizedVal.substring(5, 9));
             
            return (
                // 9 characters
                normalizedVal.length === 9 &&
                    // no set can start with zero
                    normalizedVal.match(/^[0-9]{3}[0-9]{2}[0-9]{4}/) &&                    
                    area !== 0 &&
                    area !== 666 &&
                    // it's over 900
                    area < 900 &&
                    group !== 0 &&
                    serial !== 0 &&
                    normalizedVal !== '078051120' &&
                    // was used in an ad by the Social Security Administration
                    normalizedVal !== '219099999'
            );
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.invalid-ssn')
    };

    ko.validation.rules.greaterThan = {
        validator: function (val, param) {
            return $.isNumeric(val) && val > param;
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.must-be-greater')
    };
    
    ko.validation.rules.lessThanOrEqual = {
        validator: function(val, param) {
            return $.isNumeric(val) && val <= param;
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.less-than-equal')
    };

    ko.validation.rules.ssn = {
        validator: function (val, param) {
            if (!param || val === null || val === undefined || val.toString().trim().length === 0)
                return true;

            var normalizedVal = val.replace(/-/g, '').trim();
            var area = parseInt(normalizedVal.substring(0, 3));
            var group = parseInt(normalizedVal.substring(3, 5));
            var serial = parseInt(normalizedVal.substring(5, 9));
             
            return (
                // 9 characters
                normalizedVal.length === 9 &&
                    // no set can start with zero
                    normalizedVal.match(/^[0-9]{3}[0-9]{2}[0-9]{4}/) &&                    
                    area !== 0 &&
                    area !== 666 &&
                    // it's over 900
                    area < 900 &&
                    group !== 0 &&
                    serial !== 0 &&
                    normalizedVal !== '078051120' &&
                    // was used in an ad by the Social Security Administration
                    normalizedVal !== '219099999'
            );
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.invalid-ssn')
    };

    ko.validation.rules.numeric = {
        validator: function(val) {
            return $.isNumeric(val);
        },
        message: 'must be numeric'
    };

    ko.validation.rules.alphanumeric = {
        validator: function (val) {
            return /^$|^[A-Za-z\d\s]+$/.test(val);
        },
        message: 'must be alphanumeric'
    };

    function isValidInput(val, minLength, messageKey) {
        const minCharPattern = new RegExp(`(?=.*[a-zA-Z0-9]).{${minLength},}`);
        if (!minCharPattern.test(val)) {
            this.message = $.cdh.languageConstant.getConstant(messageKey);
            return false;
        }
        return true;
    }


    ko.validation.rules.isInValidChar = {
        validator: function (val) {
            const echoAllowedCharsRegex = /^[a-zA-Z0-9'!,.\-#\/\\:;?*&+@%~_"[\]{}()|= ]+$/;
            if (!echoAllowedCharsRegex.test(val) && (val.trim() != "")) {
                this.message = $.cdh.languageConstant.getConstant("messages.allowed-characters")
                return false;
            }
            return true;
        },
        message: $.cdh.languageConstant.getConstant("messages.allowed-characters")
    };

    ko.validation.rules.providerName = {
        validator: function (val) {
            return isValidInput.call(this, val, 3, "messages.provider-name-message");
        },
        message: $.cdh.languageConstant.getConstant("messages.provider-name-message")
    };

    ko.validation.rules.address = {
        validator: function (val) {
            if (val.trim() != "") { return isValidInput.call(this, val, 1, "messages.address-message") }
            return true;
        },
        message: $.cdh.languageConstant.getConstant("messages.address-message")
    };

    ko.validation.rules.usernamevalidation = {
        validator: function (val) {
            return /^[a-zA-Z0-9._@-]+$/.test(val);
        },
        message: 'Username contains invalid characters.'
    };

    ko.validation.rules.dependentName = {
        validator: function (val) {
            return /^$|^[A-Za-z\d\s,.&'-]+$/.test(val);
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.not-allowed-characters')
    };

    ko.validation.rules.specialAddress = {
        validator: function (val) {
            return /^$|^[A-Za-z\d\s.,#:'/&-]+$/.test(val);
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.not-allowed-characters')
    };

    ko.validation.rules.notPostAddress = {
        validator: function (val) {
            return val === null || val === undefined || val.toString().match(/^\s*(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(b|box|bin)[-.\s]*)|.*((p|post)[-.\s]*(o|off|office)[-.\s]*)|.*((p|post)[-.\s]*(b|box|bin)[-.\s]*)|(box|bin)[-.\s]*)(#|n|num|number)?\s*\d+/gi) === null;
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.invalid-post-address')
    };
    
    ko.validation.rules.extendedSymbolSet = {
        validator: function(val) {
            return /^$|^[A-Za-z\d\s!@#$%^&*()_+-=/|<>?,.~`'[\]{}]+$/.test(val);
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.not-allowed-characters')
    };

    ko.validation.rules.alphabetic = {
        validator: function (val) {
            return /^$|^[a-zA-Z]+$/.test(val);
        },
        message: 'must be alphabetic'
    };
    
    ko.validation.rules.emptyValidation = {
        validator: function(val){
            return true;
        },
        message: ''
    };

    ko.validation.rules['phoneUS'] = {
        validator: function (phoneNumber, validate) {
            if (!validate) { return true; }
            if (ko.validation.utils.isEmptyVal(phoneNumber)) { return true; } // makes it optional, use 'required' rule if it should be required
            if (typeof (phoneNumber) !== 'string') { return false; }
            phoneNumber = phoneNumber.replace(/\s+/g, "");
            return validate && phoneNumber.length > 9 && phoneNumber.match(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.valid-phone-number')
    };

    ko.validation.rules['passwordComplexity'] = {
        validator: function (val, params) {
            this.message = 'See password validation message';
            
            if (val.match(/password/i)) {
                this.message = 'A password cannot contain the word "password"';
                return false;
            }
            
            if (params.userName && params.userName()) {
                if (val.toLowerCase().includes(params.userName().toLowerCase())) {
                    this.message = 'A password cannot contain the username';
                    return false;
                }
            }

            if (/\w*(\w)(?=\w*\1{2,})\w*/.test(val)) {
                this.message = 'The same character repeating 3 or more times';
                return false;
            }

            if (val.length < 8 || val.length > 16) {
                this.message = 'A valid password must contain between 8 and 16 characters.';
                return false;
            }

            if (val.match(/\s/)) {
                this.message = 'A password cannot contain spaces';
                return false;
            }

            if (! /(?=^[^\s]{8,16}$)(?!.*([A-Za-z0-9])\1{2})((?=.*?\d)(?=.*?[A-Z])(?=.*?[a-z])|(?=.*?\d)(?=.*?[^\w\d\s])(?=.*?[a-z])|(?=.*?[^\w\d\s])(?=.*?[A-Z])(?=.*?[a-z])|(?=.*?\d)(?=.*?[A-Z])(?=.*?[^\w\d\s]))^.*/.test('' + val + '')) {
                this.message = 'The password must contain 3 of the specified character types.';
                return false;
            }

            return true;
        },
        message: 'See password validation message'
    };

    ko.validation.rules['ccEmail'] = {
        validator: function (val) {
            if (ko.validation.utils.isEmptyVal(val))
                return true;
            var emails = val.split(",");
            var result = true;
            $.each(emails, function (i, item) {
                if (!(/^((([a-z]|\d|[!#\$%&'\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(item)))
                    result = false;
            });
            return result;
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.enter-proper-email')
    };

    ko.validation.rules['email'] = {
        validator: function (val) {
            if (ko.validation.utils.isEmptyVal(val)) {
                return true; // Allow empty values if not required
            }
            // Simple email regex pattern
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(val);
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.enter-proper-email') // Custom error message
    };

    ko.validation.rules.url = {
        validator: function(val) {
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/.test(val);
        },
        message: 'Please enter a proper url'
    };

    ko.validation.rules['dateGreaterThen'] = {
        validator: function (val, otherVal) {
            if (!val || !otherVal)
                return true;

            var d1 = moment(val).startOf('day');
            var d2 = moment(otherVal).startOf('day');
            return d1 >= d2;
        },
        message: function () {
            return $.cdh.languageConstant.getConstant('extension-validation.end-date-before-start-date');
        }
    };

    ko.validation.rules['dateLessThen'] = {
        validator: function (val, otherVal) {
            if (!val)
                return true;

            var d1 = moment(val).startOf('day');
            var d2 = moment(otherVal).startOf('day');
            return d1 < d2;
        },
        message: function () {
            return $.cdh.languageConstant.getConstant('extension-validation.start-date-greater-end-date');
        }
    };

    ko.validation.rules['lenghtEqual'] = {
        validator: function (val, otherVal) {
            return val.length === otherVal;
        },
        message: 'must be {0} digits'
    };

    ko.validation.rules["equalIgnoreCase"] = {
        validator: function(val, otherVal) {
            if (!val)
                val = "";
            if (!otherVal)
                otherVal = "";

            return val.toUpperCase() == otherVal.toUpperCase();
        },
        message: 'values should be equals'
    };

    ko.validation.rules['routingNumber'] = {
        validator: function(val) {
            if ((val || '').length !== 9)
                return false;

            var checkSum =
                parseInt(val[0]) * 3 +
                parseInt(val[1]) * 7 +
                parseInt(val[2]) +
                parseInt(val[3]) * 3 +
                parseInt(val[4]) * 7 +
                parseInt(val[5]) +
                parseInt(val[6]) * 3 +
                parseInt(val[7]) * 7 +
                parseInt(val[8]);

            return checkSum % 10 === 0;
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.invalid-routing-number')
    };

    ko.validation.rules['enumRequired'] = {
        validator: function(val, param) {
            return val != 0 && val != -1 || !param;
        },
        message: 'required'
    };

    ko.validation.rules['reimbRequired'] = {
        validator: function(val, param) {
            return typeof val !== 'undefined' && param || !param 
        },
        message: 'Please select a reimbursement method'
    };

    ko.validation.rules['checked'] = {
        validator: function (value) {
            return value;
        },
        message: '*'
    };

    ko.validation.rules['minArrayLength'] = {
        validator: function (obj, params) {
            return obj.length >= params.minLength;
        },
        message: "Array does not meet minimum length requirements"
    };
    
    ko.validation.rules.specificAlphanumeric = {
        validator: function (val) {
            return /^[0-9a-zA-Z-.,_]+$/g.test(val);
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.not-allowed-characters')
    };

    ko.validation.rules.zipCode = {
        validator: function (val) {
            return !val || /^\d{9}$/g.test(val) || /^\d{5}(-\d{4})?$/g.test(val);
        },
        message: $.cdh.languageConstant.getConstant('extension-validation.5-9-digit-number')
    };
    ko.validation.rules.distance = {
        validator: function (val) {
            return val >= 1 && val <= 50;
        },
        message: 'Distance must be between 1 to 50.'
    };

    ko.validation.rules.cardType = {
        validator: function (val) {
            if(!val) {
                return true;
            }

            var cardType = $.payform.parseCardType(val);
            return $.payform.validateCardNumber(val) && (cardType === 'mastercard' || cardType === 'visa' || cardType === 'amex');
        },
        message: 'Invalid card number'
    };

    // override default validation error message behavior
    ko.validation.insertValidationMessage = function (element) {
        var span = document.createElement('SPAN');
        span.className = ko.validation.utils.getConfigOptions(element).errorMessageClass;
        if (!element.id) {
            element.id = Math.random();
        }
        span.id = element.id + '_validation_message';
        span.setAttribute('role', 'alert');
        var ariaDescribedby = element.getAttribute('aria-describedby') || '';
        if (ariaDescribedby) {
            ariaDescribedby += ' ';
        }
        element.setAttribute('aria-describedby', ariaDescribedby + span.id);
        element.parentNode.insertBefore(span, element);
        return span;
    };

    ko.validation.rules.required.message = $.cdh.languageConstant.getConstant('extension-validation.required-message');
    ko.validation.rules.min.message = $.cdh.languageConstant.getConstant('extension-validation.must-be-at-least');
    ko.validation.rules.max.message = $.cdh.languageConstant.getConstant('extension-validation.must-be-no-more-than');

    ko.validation.registerExtenders();
    
    // validation model
    var validationModel = function (obj, on, options) {
        options = $.extend({
            recreateValidation: true
        }, options);

        var errors = null;
        var createValidationIfNeeded = function () {
            if (errors != null && options.recreateValidation === false)
                return;

            errors = ko.validation.group(obj, { deep: true });
        }

        this.activated = ko.observable(false);
        this.errorsList = ko.observable(errors);

        this.validationValid = ko.pureComputed(function() {
            return this.activated() ? !this.hasErrors() : true;
        }, this);
        this.hasErrors = ko.pureComputed(function () {
            // TODO: refactor this without side effect (this is hotfix workaround, bc. errors is not observable)
            this.errorsList(errors !== null ? errors() : null);
            return this.activated() && errors().length > 0;
        }, this);

        this.getErrors = ko.pureComputed(function() {
            
            return errors !== null && errors()
        }, this);

        this.activate = function () {
            if (!this.activated()) {
                createValidationIfNeeded();

                errors.showAllMessages();
                this.activated(true);
                if (this.hasErrors()) {
                    scrollToError();
                }
            }
            
        }.bind(this);
        
        this.scrollToError = function () {
            scrollToError();
        }.bind(this);

        this.deactivate = function (forceInitErrors) {
            if (errors === null && forceInitErrors) {
                createValidationIfNeeded();
            }
            if (errors != null) {
                errors.showAllMessages(false);
            }
            this.activated(false);
        }.bind(this);

        function scrollToError() {
            if ($.magnificPopup.instance.isOpen) {
                scrollToErrorPopup();
            } else {
                scrollToErrorWindow();
            }
        }
        
        function scrollToErrorWindow() {
            const elementToScroll = $(".popup-form_error-title")[0];
            if (elementToScroll) {
                $(window).scrollTop($(elementToScroll).offset().top);
            }
        }
        
        function scrollToErrorPopup() {
            const contentContainer = $.magnificPopup.instance.container[0];
            if(!contentContainer) return;
            
            const scroller = $.magnificPopup.instance.container[0].parentElement;
            if(!scroller) return;
            
            const elementToScroll = document.querySelector("div.popup-row_inp-error");
            if(!elementToScroll) return;
            
            scroller.scrollTop = elementToScroll.offsetTop - scroller.offsetTop;
        }
        
        
        if (on === true)
            this.activate();
    };

    $.extend(true, $, {
        cdh: {
            validation: validationModel
        }
    });
})(jQuery, ko);
// ReSharper restore MisuseOfOwnerFunctionThis
